export function scriptInsert(url,sucess,failed) {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.onload = () => {
            if(sucess) sucess();
            resolve(true);
        };
        script.onerror = (err) => {
            if(failed) failed();
            reject(err);
        };
        document.getElementsByTagName('head')[0].appendChild(script)
    })
}
export function iosDetect() {
    const
        ua = navigator.userAgent,
        ios = !!ua.match(/Mac OS X/i);
    return ios;
}
export function wapDetect() {
    const
        ua = navigator.userAgent.toLocaleLowerCase(),
        isSafari = ua.indexOf("safari") != -1 && ua.indexOf("version") != -1,
        isIphone = ua.indexOf("iphone") != -1 && ua.indexOf("version") != -1,
        isIPad = isSafari && !isIphone && 'ontouchend' in document;
    return ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) || isIPad;
}
export function setPageInfo(parma) {
    if (parma.title) {
        document.title = parma.title;
    }
    if (parma.keywords) {
        let
            meta = document.createElement('meta');
        meta.content = parma.keywords;
        meta.name = 'keywords';
        document.getElementsByTagName('head')[0].appendChild(meta);
    }
    if (parma.description) {
        let
            meta = document.createElement('meta');
        meta.content = parma.description;
        meta.name = 'description';
        document.getElementsByTagName('head')[0].appendChild(meta);
    }
}